<template>
  <div class="banner-home">
    <div class="relative bg-yellow">
      <!-- Todo el banner (imagen + franja) es el área clickeable. El botón ya no
           lleva @click: el evento sube por burbujeo hasta este contenedor. -->
      <div
        class="banner-desktop-wrapper"
        :class="{ 'banner-wrapper--loading': !desktopBannerLoaded }"
        :aria-busy="!desktopBannerLoaded"
        @click="desktopBannerLoaded && goToRecomendedCourses()"
      >
        <div class="banner-prime-container only-desktop" :class="{ 'hidden-on-mobile-menu': isMobileMenuOpen }">
          <div
            v-if="!desktopBannerLoaded"
            class="banner-prime-placeholder banner-prime-placeholder--desktop"
            role="status"
            aria-label="Cargando banner"
          ></div>
          <img
            v-if="campaignBannersResolved"
            v-show="desktopBannerLoaded"
            :src="bannerPrime" 
            alt="Programa Intensivo" 
            class="banner-prime-image"
            @load="handleBannerLoad('desktop')"
            @error="handleBannerError('desktop')"
          />
        </div>
        <div
          class="banner-desktop-cta-band"
          :class="{ 'banner-cta-band--loading': !desktopBannerLoaded }"
        >
          <button type="button" class="banner-cta-button">
            Cotiza Aquí
          </button>
        </div>
      </div>
      <div
        class="banner-mobile-wrapper"
        :class="{ 'banner-wrapper--loading': !mobileBannerLoaded }"
        :aria-busy="!mobileBannerLoaded"
        @click="mobileBannerLoaded && goToRecomendedCourses()"
      >
        <div class="banner-prime-container only-mobile">
          <div
            v-if="!mobileBannerLoaded"
            class="banner-prime-placeholder banner-prime-placeholder--mobile"
            role="status"
            aria-label="Cargando banner"
          ></div>
          <img
            v-if="campaignBannersResolved"
            v-show="mobileBannerLoaded"
            :src="bannerMobile" 
            alt="Programa Intensivo Mobile" 
            class="banner-prime-image"
            @load="handleBannerLoad('mobile')"
            @error="handleBannerError('mobile')"
          />
        </div>
        <div
          class="banner-mobile-cta-band"
          :class="{ 'banner-cta-band--loading': !mobileBannerLoaded }"
        >
          <button type="button" class="banner-cta-button">
            Cotiza Aquí
          </button>
        </div>
      </div>
      <div class="pdv-container">
        <div class="banner-home-content">
        </div>
      </div>

    </div>

      <!-- Statistics Cards -->
      <div class="statistics-section" style="margin-top: 40px; margin-bottom: 48px;">
        <div class="pdv-container">
          <div class="statistics-cards">
            <div class="discount-banner">
              <div class="discount-content">
                <div class="discount-badge">100%</div>
                <p class="discount-text">
                  <strong>100% de nuestras sedes</strong><br>
                  obtuvieron puntajes máximos nacionales
                </p>
              </div>
            </div>
            
           
            
            <div class="discount-banner">
              <div class="discount-content">
                <div class="discount-badge">+700</div>
                <p class="discount-text">
                  <strong>Más de 700 puntajes máximos nacionales</strong><br>
                  se prepararon con nosotros
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <CardsLanding />
    </div>
  </template>

<script>
// import Button from "@/components/featured/Button";
import CardsLanding from "@/components/featured/CardsLanding.vue";
import bannersService from "@/services/bannersService";
import bannerPrime from "@/assets/adminsion2027-2.webp";
import bannerMobile from "@/assets/admision2027mobile-2.webp";
export default {
  components: {
    // Button,
    CardsLanding,
  },
  data() {
    return {
      enabledPrograms: [],
      highSchoolAcademy: null,
      bachelorsAcademy: null,
      pdvX: null,
      discount: null,
      defaultBannerPrime: bannerPrime,
      defaultBannerMobile: bannerMobile,
      cmsBannerDesktop: "",
      cmsBannerMobile: "",
      campaignBannersResolved: false,
      desktopBannerLoaded: false,
      mobileBannerLoaded: false,
      isMobileMenuOpen: false,
    };
  },
  computed: {
    bannerPrime() {
      if (!this.campaignBannersResolved) return "";
      return this.cmsBannerDesktop || this.defaultBannerPrime;
    },
    bannerMobile() {
      if (!this.campaignBannersResolved) return "";
      return this.cmsBannerMobile || this.defaultBannerMobile;
    },
  },
  methods: {
    async loadCampaignBanners() {
      try {
        const banners = await bannersService.getCampaignBanners();
        if (banners.home) {
          this.cmsBannerDesktop = typeof banners.home.desktop === "string"
            ? banners.home.desktop.trim()
            : "";
          this.cmsBannerMobile = typeof banners.home.mobile === "string"
            ? banners.home.mobile.trim()
            : "";
        }
      } catch (error) {
        console.error("Error loading campaign banners:", error);
      } finally {
        // La imagen local se evalúa como respaldo solo después de consultar el CMS.
        this.campaignBannersResolved = true;
      }
    },
    handleBannerLoad(device) {
      if (device === "desktop") {
        this.desktopBannerLoaded = true;
        return;
      }

      this.mobileBannerLoaded = true;
    },
    handleBannerError(device) {
      if (device === "desktop" && this.cmsBannerDesktop) {
        this.cmsBannerDesktop = "";
        return;
      }

      if (device === "mobile" && this.cmsBannerMobile) {
        this.cmsBannerMobile = "";
        return;
      }

      console.error(`Error loading ${device} fallback banner`);
    },
    goToRecomendedCourses() {
      this.$router.push({
        path: "/inscripcion/paso-1",
        query: { ...this.$route.query }

      });
    },
    loadEnabledPrograms() {
      this.Axios.get("/programs/enabled").then((response) => {
        this.enabledPrograms = response.data;
        this.highSchoolAcademy = response.data[0];
        this.bachelorsAcademy = response.data[1];
        this.pdvX = response.data[2];
      });
    },
    configureSelectedProgram(program, isPdvX) {
      this.$store.dispatch("addSelectedProgramInfo", { ...program, isPdvX });
    },
    goToStudentForm(program, formPageName, isPdvX) {
      // this.$router.push({ name: 'Step1' });
      this.$store.dispatch("cleanLocalStorage");
      this.configureSelectedProgram(program, isPdvX);
      this.$router.push({ 
        name: formPageName,
        query: this.$route.query
      });
    },
    observeMobileMenu() {
      // Observar el elemento del menú móvil
      const menuElement = document.getElementById('menu-mobile');
      if (menuElement) {
        this.menuObserver = new MutationObserver(() => {
          this.isMobileMenuOpen = menuElement.classList.contains('open');
        });
        
        this.menuObserver.observe(menuElement, {
          attributes: true,
          attributeFilter: ['class']
        });
        
        // Verificar estado inicial
        this.isMobileMenuOpen = menuElement.classList.contains('open');
      }
      
      // También observar cambios en el body overflow como fallback
      const bodyObserver = new MutationObserver(() => {
        const bodyOverflow = document.body.style.overflow;
        if (bodyOverflow === 'hidden' && window.innerWidth <= 768) {
          this.isMobileMenuOpen = true;
        } else if (bodyOverflow !== 'hidden') {
          // Solo actualizar si el menú no tiene la clase open
          const menuElement = document.getElementById('menu-mobile');
          if (menuElement && !menuElement.classList.contains('open')) {
            this.isMobileMenuOpen = false;
          }
        }
      });
      
      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['style']
      });
      
      this.bodyObserver = bodyObserver;
    },
  },
  mounted() {
    this.loadCampaignBanners();
    this.Axios.get("/dashadmin/infogeneral").then((response) => {
      this.discount = response.data[0].discount;
    });
    setInterval(this.discountSeconds, 1000);
    
    // Observar cambios en el menú móvil para ocultar el banner
    this.observeMobileMenu();
  },
  beforeDestroy() {
    if (this.menuObserver) {
      this.menuObserver.disconnect();
    }
    if (this.bodyObserver) {
      this.bodyObserver.disconnect();
    }
  },
};
</script>

<style lang="scss" scoped>
.banner-home {
  background: $neutralwhite;

  @media (min-width: 769px) {
    .relative.bg-yellow {
      background: transparent !important;
    }
  }

  .bg-yellow {
    background: transparent !important; /* Eliminar fondo amarillo en desktop y mobile */
    filter: none !important;
    mix-blend-mode: normal !important;
    
    @media (max-width: 768px) {
      background: transparent !important; /* Eliminar fondo amarillo en mobile */
    }
    
    &::before,
    &::after {
      display: none !important;
      content: none !important;
    }
    
    &.relative {
      &::before,
      &::after {
        display: none !important;
        content: none !important;
      }
    }
  }

  .banner-cta-button {
    position: absolute;
    bottom: 12%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 110;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    min-width: 160px;
    padding: 12px 28px;
    background-color: #1a1a1a;
    color: #fff;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    text-decoration: none;
    border-radius: 50px;
    border: 2px solid #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background-color: #333;
      transform: translateX(-50%) scale(1.03);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.45);
    }

    &:active {
      background-color: #000;
      transform: translateX(-50%) scale(0.97);
    }

    /* En desktop se ubica abajo a la derecha para no tapar el texto del banner */
    @media (min-width: 769px) {
      padding: 14px 62px;
      font-size: 20px;
      min-width: 200px;
      left: auto;
      right: 4%;
      bottom: 14%;
      transform: none;
      outline: rgba(12, 11, 11, 0.25) solid 5px;

      &:hover {
        transform: scale(1.03);
      }

      &:active {
        transform: scale(0.97);
      }
    }
  }

  /* Franja amarilla pegada bajo el banner mobile con el botón centrado */
  .banner-mobile-cta-band {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background-color: #ffd200;
      padding: 10px 20px 24px;
      margin-top: -1px; /* pegado al banner, evita línea entre imagen y franja */
      position: relative;
      z-index: 55;
    }

    /* El botón dentro de la franja deja de ser absoluto y se centra en el flujo */
    .banner-cta-button {
      position: static;
      left: auto;
      right: auto;
      bottom: auto;
      transform: none;

      &:hover,
      &:active {
        transform: none;
      }
    }
  }

  /* Franja amarilla pegada bajo el banner desktop con el botón centrado */
  .banner-desktop-cta-band {
    display: none;

    @media (min-width: 769px) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background-color: #ffd200;
      padding: 18px 20px;
      margin-top: -1px; /* pegado al banner, evita línea entre imagen y franja */
      position: relative;
      z-index: 55;
    }

    /* El botón dentro de la franja deja de ser absoluto y se centra en el flujo */
    .banner-cta-button {
      position: static;
      left: auto;
      right: auto;
      bottom: auto;
      transform: none;
      outline: none; /* el halo era para contrastar sobre la imagen, sobre el amarillo no hace falta */

      &:hover {
        transform: scale(1.03);
      }

      &:active {
        transform: scale(0.97);
      }
    }
  }

  .banner-prime-container {
    width: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
    position: relative;
    z-index: 100;
    
    &::before,
    &::after {
      display: none;
      content: none;
    }
    
    &.only-desktop {
      @media (min-width: 769px) {
        display: block;
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 0;
      }

      @media (max-width: 768px) {
        display: none !important; /* Ocultar completamente el banner desktop en mobile */
      }
    }
    
    &.only-mobile {
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 768px) {
        display: flex !important; /* Mostrar el banner móvil solo en mobile */
        z-index: 50; /* Por debajo del menú móvil (z-index: 100) */
      }
    }
  }

  .banner-prime-placeholder {
    width: 100%;
    background: linear-gradient(90deg, #f1f1f1 25%, #fafafa 50%, #f1f1f1 75%);
    background-size: 200% 100%;
    animation: banner-loading 1.4s ease-in-out infinite;

    &--desktop {
      aspect-ratio: 1200 / 450;
    }

    &--mobile {
      min-height: 200px;
      height: min(93.75vw, 450px);
    }
  }

  .banner-wrapper--loading {
    cursor: default;
  }

  .banner-cta-band--loading {
    visibility: hidden;
  }

  @keyframes banner-loading {
    from {
      background-position: 200% 0;
    }

    to {
      background-position: -200% 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .banner-prime-placeholder {
      animation: none;
    }
  }

  /* Contenedor clickeable del banner desktop (imagen + franja) */
  .banner-desktop-wrapper {
    display: none;
    width: 100%;
    cursor: pointer;

    @media (min-width: 769px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .banner-mobile-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    cursor: pointer;

    @media (min-width: 769px) {
      display: none;
    }
  }

  .banner-mobile-cta {
    display: none;
    width: fit-content;
    min-width: 160px;
    max-width: 220px;
    margin: 12px auto 0;
    padding: 12px 28px;
    background-color: #3691d8;
    color: #fff;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
    text-decoration: none;
    justify-content: center;
    align-items: center;

    border-radius: 50px;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(54, 145, 216, 0.4);
    z-index: 60;
    position: relative;

    @media (max-width: 768px) {
      display: flex;
    }
  }

  .banner-mobile-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 6% 10% 12% 8%;
    z-index: 60;
    pointer-events: none;

    @media (max-width: 420px) {
      padding: 4% 8% 8% 6%;
    }

    @media (min-width: 769px) {
      display: none;
    }
  }

  .banner-mobile-badge {
    display: inline-block;
    background-color: #ffd200;
    color: #000;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.05em;
    padding: 6px 14px;
    border-radius: 50px;
    margin-bottom: 8px;
    text-shadow: none;

    @media (max-width: 420px) {
      font-size: 11px;
      padding: 4px 10px;
      margin-bottom: 4px;
    }

    &--wide {
      padding: 6px 12px;
      font-size: 12px;
      margin-bottom: 4px;

      @media (max-width: 420px) {
        font-size: 10px;
        padding: 4px 8px;
      }
    }
  }

  .banner-mobile-title {
    font-family: "Poppins", sans-serif;
    font-weight: 800;
    font-size: 32px;
    letter-spacing: -0.02em;
    line-height: 1.1;
    margin: 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);

    @media (max-width: 420px) {
      font-size: 24px;
    }

    &--white {
      color: #fff;
    }

    &--yellow {
      color: #ffd200;
      margin-bottom: 4px;
      transform: translateX(35px);

      @media (max-width: 420px) {
        transform: translateX(20px);
      }
    }
  }

  .banner-mobile-subtitle {
    color: #fff;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 16px;
    margin: 20px 0 4px 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);

    @media (max-width: 420px) {
      font-size: 13px;
      margin: 12px 0 2px 0;
    }
  }

  .banner-mobile-discount {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    margin-top: 2px;

    &-labels {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &-value {
      font-family: "Poppins", sans-serif;
      font-weight: 800;
      font-size: 72px;
      color: #fff;
      line-height: 1;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);

      @media (max-width: 420px) {
        font-size: 52px;
      }
    }

    &-label {
      font-family: "Poppins", sans-serif;
      font-weight: 700;
      font-size: 18px;
      color: #fff;
      margin: 0;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);

      @media (max-width: 420px) {
        font-size: 14px;
      }

      &--percent {
        font-size: 28px;

        @media (max-width: 420px) {
          font-size: 20px;
        }
      }
    }
  }

  .banner-home-button-overlay {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
    display: flex;
    justify-content: center;
    align-items: center;
    
    @media (max-width: 768px) {
      z-index: 51; /* Menor que el menú móvil pero mayor que el banner */
    }
  }

  .banner-home-button-overlay-mobile {
    position: absolute;
    bottom: 10px;
    left: 75%;
    transform: translateX(-50%);
    z-index: 101;
    display: none;
    justify-content: center;
    align-items: center;
    
    @media (max-width: 768px) {
      display: flex !important; /* Mostrar solo en mobile */
      z-index: 51; /* Por encima del banner pero por debajo del menú (z-index: 100) */
    }
  }

  .banner-prime-image {
    display: block;
    position: relative;
    z-index: 100;
    filter: none !important;
    mix-blend-mode: normal !important;

    &::before,
    &::after {
      display: none !important;
      content: none !important;
    }

    @media (min-width: 769px) {
      width: 100%;
      height: auto;
      max-width: 100%;
    }

    @media (max-width: 768px) {
      width: 100%;
      max-width: 100%;
      height: auto;
      min-height: 200px;
      max-height: 450px;
      object-fit: cover;
      object-position: center;
      z-index: 49; /* Menor que el menú móvil (z-index: 100) */
    }
  }
}
.banner-home-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  @media (max-width: 768px) {
    margin: 0 24px;
  }

  @media (min-width: 769px) {
    margin: 0 180px;
  }

  .banner-home-title2 {
    margin-bottom: 0;
    color: white;
    padding: 10px;
    background-color: black;
    font-family: "Poppins-ExtraBold", sans-serif;
    z-index: 10;

    @media (max-width: 768px) {
      margin-top: 24px;
      margin-bottom: 8px;
      font-size: 31px;
      line-height: 30px;
      text-align: left;
    }
    @media (min-width: 769px) {
      margin-top: 40px;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
    }
  }

  .banner-home-text {
    font-family: "Poppins-Regular", sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 27px;
    line-height: 37px;
    letter-spacing: 0px;
    text-align: center;
    color: $neutral80;
    z-index: 10;
    margin: 16px 0 24px 0;
    color: #3B3C3F;
  }

  .banner-home-title {
    background-color: white;
    padding: 8px;
    color: $colorTerciario;
    font-family: "Poppins-ExtraBold", sans-serif;
    z-index: 10;

    @media (max-width: 768px) {
      margin-bottom: 2px;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }
    @media (min-width: 769px) {
      margin-top: 16px;
      font-size: 48px;
      line-height: 58px;
      text-align: center;
    }
  }

  .banner-home-green-content {
    background-color: transparent;
    padding: 24px 20px;
    border-radius: 8px 24px 8px 8px;
    border: 4px solid white;
    display: flex;
    flex-direction: column;
    z-index: 10;
    position: relative;
    &:hover {
      cursor: pointer;
    }

    @media (max-width: 768px) {
      width: 100%;
      padding: 16px 16px;
      /* Asegurar que el contenedor no corte el contenido */
      overflow: visible;
      min-width: 0;
      text-align: center;
    }
    @media (min-width: 769px) {
      width: auto;
      text-align: center;
    }

    .gree-arrow {
      position: absolute;
      width: 37px;
      height: 37px;
      left: -17px;
      bottom: -22px;
    }

    .first-text {
      color: #000;
      margin-bottom: 10px;
      font-size: 22px;
      line-height: 28px;
      font-family: "Poppins-Medium", sans-serif;

      @media (max-width: 768px) {
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 8px;
      }
    }

    .second-text {
      color: #fff;
      margin-bottom: 10px;
      font-size: 29px;
      line-height: 28px;
      padding-top: 8px;
      font-family: "Poppins-Medium", sans-serif;
    }

    h2 {
      color: #000;
      font-size: 40px;
      line-height: 50px;
      font-family: "Poppins-Bold", sans-serif;
      margin-bottom: 0;
      /* Asegurar que el texto se vea completo en una sola línea */
      white-space: nowrap;
      overflow: visible;
      text-overflow: clip;

      @media (max-width: 768px) {
        font-size: 28px;
        line-height: 32px;
        /* Asegurar que el texto se vea completo en mobile */
        white-space: nowrap;
        overflow: visible;
        text-overflow: clip;
        /* Ajustar el contenedor para que no corte el texto */
        min-width: 0;
        width: auto;
      }

      @media (max-width: 480px) {
        font-size: 24px;
        line-height: 28px;
      }

      span {
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          margin-bottom: 0;
          font-size: 28px !important;
          line-height: 32px !important;
        }
        
        @media (max-width: 480px) {
          font-size: 24px !important;
          line-height: 28px !important;
        }
      }
    }
  }

  .banner-home-button-content {
    z-index: 10;
    @media (max-width: 768px) {
      margin-top: 28px;
      margin-bottom: 18px;
      width: 100%;
    }
    @media (min-width: 769px) {
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
}

.banner-texture-mobile {
  background-image: url("/images/featured/texture-home-mobile.svg");
  background-size: cover;
  background-repeat: no-repeat;
  top: -20px;
  right: 0;
  left: 0;
  bottom: 0;
}
.banner-texture-desktop {
  background-image: url("/images/featured/texture-home-desktop.svg");
  background-size: cover;
  background-repeat: no-repeat;
  top: -20px;
  right: 0;
  left: 0;
  bottom: 0;
}

.descuento {
  font-family: "Poppins-ExtraBold", sans-serif;
  font-size: 30px;
  font-weight: bold;
  color: black;
  padding-top: 20px;
}

/* Statistics Section */
.statistics-section {
  background: #FFFFFF;
  padding: 20px 0 20px 0;
}

.statistics-cards {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 108px;
  max-width: 936px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 48px;
  }
}

/* Discount Banner */
.discount-banner {
  position: relative;
  z-index: 10;
}

.discount-content {
  width: 300px;
  background-color: white;
  border-radius: 12px;
  border: 2px solid #fbbf24;
  padding: 1.2rem 1.2rem;
  position: relative;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.discount-content::before {
  content: '';
  position: absolute;
  width: 239px;
  height: 57px;
  background-color: #FFEA8A;
  top: -16px;
  left: 79px;
  z-index: -1;
}

.discount-content::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #FFE25C;
  top: 91px;
  left: -13px;
  z-index: -1;
}

.discount-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #1a1a1a;
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  font-weight: 800;
  font-size: 1.25rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: -0.02em;
  min-width: 48px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.discount-badge.highlight {
  background-color: #1a1a1a;
  color: white;
}

.discount-text {
  color: #4a4a4a;
  font-weight: 400;
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.discount-text strong {
  font-weight: 700;
  color: #1a1a1a;
}
</style>

